module.exports = __webpack_public_path__ + "img/icon_reserv_check.8872bf93.svg";